import { normalize } from './normalize';
import { formatDateDDMMYYYY, parseSheetDate } from './dates';

// Canonical analysis utilities
// PRESERVED EXACT COMPLIANCE with original src/utils.js

// Function to analyze multi-car contracts
// This function groups contracts by Contract No. and finds contracts with multiple different cars
export const analyzeMultiCarContracts = (data) => {
    // تجميع العقود حسب رقم العقد وتجميع السيارات داخل كل عقد
    const contractGroups = {};
    const debugCounts = {};
    // دالة تطبيع رقم اللوحة
    const normalizePlate = (str) => (str || '').toString().replace(/\s+/g, '').toUpperCase();
    data.forEach(row => {
        const contractNo = row['Contract No.'];
        const plateNumberRaw = row['Plate Number'];
        const plateNumber = normalizePlate(plateNumberRaw);

        // Try multiple variations for Customer and Model
        const customerName = row['Customer Name'] || row['Customer'] || row['customer'] || row['Name'] || '';
        const carModel = row['Car Model'] || row['Model'] || row['model'] || row['Vehicle'] || '';

        const revenueDateValue = row['Revenue Date'];
        const revenueDate = parseSheetDate(revenueDateValue);

        if (!contractNo || !plateNumber || !revenueDate) {
            return;
        }
        if (!contractGroups[contractNo]) {
            contractGroups[contractNo] = {
                contractNo,
                customerName,
                cars: {},
                carsRaw: {},
            };
        }
        if (!contractGroups[contractNo].cars[plateNumber]) {
            contractGroups[contractNo].cars[plateNumber] = {
                plateNumber,
                carModel,
                dates: [],
            };
            contractGroups[contractNo].carsRaw[plateNumber] = plateNumberRaw;
        }
        contractGroups[contractNo].cars[plateNumber].dates.push(revenueDate);
    });

    // تجهيز النتائج النهائية
    const results = [];
    Object.values(contractGroups).forEach(contract => {
        debugCounts[contract.contractNo] = Object.keys(contract.cars).length + ' => [' + Object.values(contract.carsRaw).join(', ') + ']';
        const carEntries = Object.values(contract.cars);
        if (carEntries.length <= 1) return; // استبعاد العقود التي بها سيارة واحدة فقط
        const carDetails = carEntries.map(car => {
            // حساب أول وآخر تاريخ
            const sortedDates = car.dates.sort((a, b) => a - b);
            return {
                plateNumber: car.plateNumber,
                carModel: car.carModel,
                from: formatDateDDMMYYYY(sortedDates[0]),
                to: formatDateDDMMYYYY(sortedDates[sortedDates.length - 1])
            };
        });
        results.push({
            contractNo: contract.contractNo,
            customerName: contract.customerName,
            carsCount: carEntries.length,
            carDetails
        });
        // Debug: عرض العقود وعدد السيارات
        // alert('عقود وعدد السيارات:\n' + Object.entries(debugCounts).map(([c, n]) => c + ': ' + n).join('\n'));
    });
    return results;
};

// The maintenance log by plate, built once per log array (owner, 28 Sep 2026: the Monthly page took ~4 s). The
// Monthly table, its row menus and its copy menu ask per row on every render; each ask used to filter every log
// (~1,500), normalising both plates again. The page's log arrays are React state - replaced by a load, never changed
// in place - so the array itself keys its index: a new load, a new index.
const logIndexes = new WeakMap();
const plateLogs = (maintenanceData, plate) => {
    let byPlate = logIndexes.get(maintenanceData);
    if (!byPlate) {
        byPlate = new Map();
        maintenanceData.forEach((m) => {
            const key = normalize(m["Vehicle"]);
            const entry = byPlate.get(key);
            if (entry) entry.logs.push(m); else byPlate.set(key, { logs: [m] });
        });
        logIndexes.set(maintenanceData, byPlate);
    }
    return byPlate.get(normalize(plate)) || null;
};

// Switch / Switch Back (the contract on another car, its own car ready) are utils/switchBack's (4 Nov 2026).

export const getIssueForRow = (row, maintenanceData) => {
    if (!row || !row.invygoPlate || !maintenanceData) return '';
    const entry = plateLogs(maintenanceData, row.invygoPlate);   // the plate's logs, in the log's order
    const matchingVehicles = entry ? entry.logs : [];
    if (matchingVehicles.length > 0) {
        const vehicleWithoutDateIn = matchingVehicles.find(
            (m) => !m['Date IN'] || m['Date IN'].trim() === ''
        );
        if (vehicleWithoutDateIn) {
            return vehicleWithoutDateIn['Damage Details'] || '';
        }
    }
    return '';
};
